module.exports = __webpack_public_path__ + "img/image_section1.36403b35.png";